export const addStringIfUnique =
    (array: string[]) =>
    (stringToAdd: string): string[] =>
        array.includes(stringToAdd) ? array : array.concat(stringToAdd);
